/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import * as reactQuery from '@tanstack/react-query';
import { type ApiContext, useApiContext, queryKeyFn } from './apiContext';
import { deepMerge } from './apiUtils';
import type * as Fetcher from './apiFetcher';
import { apiFetch } from './apiFetcher';
import type * as Schemas from './apiSchemas';

type QueryFnOptions = {
  signal?: AbortController['signal'];
};

export type DefectRepairV1ControllerCreateError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectRepairV1ControllerCreateVariables = {
  body: Schemas.DefectRepairCreateV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchDefectRepairV1ControllerCreate = (
  variables: DefectRepairV1ControllerCreateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectRepairCreateV1OutputDto,
    DefectRepairV1ControllerCreateError,
    Schemas.DefectRepairCreateV1InputDto,
    {},
    {},
    {}
  >({ url: '/scan/defect-repair', method: 'post', ...variables, signal });

export const useDefectRepairV1ControllerCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DefectRepairCreateV1OutputDto,
      DefectRepairV1ControllerCreateError,
      DefectRepairV1ControllerCreateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.DefectRepairCreateV1OutputDto,
    DefectRepairV1ControllerCreateError,
    DefectRepairV1ControllerCreateVariables
  >({
    mutationFn: (variables: DefectRepairV1ControllerCreateVariables) =>
      fetchDefectRepairV1ControllerCreate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type DefectRepairTypeV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type DefectRepairTypeV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type DefectRepairTypeV1ControllerGetByProjectVariables = {
  queryParams: DefectRepairTypeV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchDefectRepairTypeV1ControllerGetByProject = (
  variables: DefectRepairTypeV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.DefectRepairTypeV1OutputDto,
    DefectRepairTypeV1ControllerGetByProjectError,
    undefined,
    {},
    DefectRepairTypeV1ControllerGetByProjectQueryParams,
    {}
  >({ url: '/scan/defect-repair-type', method: 'get', ...variables, signal });

export function defectRepairTypeV1ControllerGetByProjectQuery(
  variables: DefectRepairTypeV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.DefectRepairTypeV1OutputDto>;
};

export function defectRepairTypeV1ControllerGetByProjectQuery(
  variables:
    | DefectRepairTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.DefectRepairTypeV1OutputDto>)
    | reactQuery.SkipToken;
};

export function defectRepairTypeV1ControllerGetByProjectQuery(
  variables:
    | DefectRepairTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/defect-repair-type',
      operationId: 'defectRepairTypeV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDefectRepairTypeV1ControllerGetByProject(variables, signal),
  };
}

export const useSuspenseDefectRepairTypeV1ControllerGetByProject = <
  TData = Schemas.DefectRepairTypeV1OutputDto,
>(
  variables: DefectRepairTypeV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectRepairTypeV1OutputDto,
      DefectRepairTypeV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DefectRepairTypeV1OutputDto,
    DefectRepairTypeV1ControllerGetByProjectError,
    TData
  >({
    ...defectRepairTypeV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDefectRepairTypeV1ControllerGetByProject = <
  TData = Schemas.DefectRepairTypeV1OutputDto,
>(
  variables:
    | DefectRepairTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DefectRepairTypeV1OutputDto,
      DefectRepairTypeV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.DefectRepairTypeV1OutputDto,
    DefectRepairTypeV1ControllerGetByProjectError,
    TData
  >({
    ...defectRepairTypeV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QuarantineDefectV1ControllerGetByIdPathParams = {
  id: string;
};

export type QuarantineDefectV1ControllerGetByIdError =
  Fetcher.ErrorWrapper<undefined>;

export type QuarantineDefectV1ControllerGetByIdVariables = {
  pathParams: QuarantineDefectV1ControllerGetByIdPathParams;
} & ApiContext['fetcherOptions'];

export const fetchQuarantineDefectV1ControllerGetById = (
  variables: QuarantineDefectV1ControllerGetByIdVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuarantineDefectV1OutputDto,
    QuarantineDefectV1ControllerGetByIdError,
    undefined,
    {},
    {},
    QuarantineDefectV1ControllerGetByIdPathParams
  >({
    url: '/scan/quarantine-defect/{id}',
    method: 'get',
    ...variables,
    signal,
  });

export function quarantineDefectV1ControllerGetByIdQuery(
  variables: QuarantineDefectV1ControllerGetByIdVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.QuarantineDefectV1OutputDto>;
};

export function quarantineDefectV1ControllerGetByIdQuery(
  variables:
    | QuarantineDefectV1ControllerGetByIdVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.QuarantineDefectV1OutputDto>)
    | reactQuery.SkipToken;
};

export function quarantineDefectV1ControllerGetByIdQuery(
  variables:
    | QuarantineDefectV1ControllerGetByIdVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/quarantine-defect/{id}',
      operationId: 'quarantineDefectV1ControllerGetById',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchQuarantineDefectV1ControllerGetById(variables, signal),
  };
}

export const useSuspenseQuarantineDefectV1ControllerGetById = <
  TData = Schemas.QuarantineDefectV1OutputDto,
>(
  variables: QuarantineDefectV1ControllerGetByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectV1OutputDto,
      QuarantineDefectV1ControllerGetByIdError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.QuarantineDefectV1OutputDto,
    QuarantineDefectV1ControllerGetByIdError,
    TData
  >({
    ...quarantineDefectV1ControllerGetByIdQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useQuarantineDefectV1ControllerGetById = <
  TData = Schemas.QuarantineDefectV1OutputDto,
>(
  variables:
    | QuarantineDefectV1ControllerGetByIdVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectV1OutputDto,
      QuarantineDefectV1ControllerGetByIdError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.QuarantineDefectV1OutputDto,
    QuarantineDefectV1ControllerGetByIdError,
    TData
  >({
    ...quarantineDefectV1ControllerGetByIdQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QuarantineDefectTypeV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type QuarantineDefectTypeV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type QuarantineDefectTypeV1ControllerGetByProjectVariables = {
  queryParams: QuarantineDefectTypeV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchQuarantineDefectTypeV1ControllerGetByProject = (
  variables: QuarantineDefectTypeV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.QuarantineDefectTypeV1OutputDto,
    QuarantineDefectTypeV1ControllerGetByProjectError,
    undefined,
    {},
    QuarantineDefectTypeV1ControllerGetByProjectQueryParams,
    {}
  >({
    url: '/scan/quarantine-defect-type',
    method: 'get',
    ...variables,
    signal,
  });

export function quarantineDefectTypeV1ControllerGetByProjectQuery(
  variables: QuarantineDefectTypeV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.QuarantineDefectTypeV1OutputDto>;
};

export function quarantineDefectTypeV1ControllerGetByProjectQuery(
  variables:
    | QuarantineDefectTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.QuarantineDefectTypeV1OutputDto>)
    | reactQuery.SkipToken;
};

export function quarantineDefectTypeV1ControllerGetByProjectQuery(
  variables:
    | QuarantineDefectTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/quarantine-defect-type',
      operationId: 'quarantineDefectTypeV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchQuarantineDefectTypeV1ControllerGetByProject(
              variables,
              signal,
            ),
  };
}

export const useSuspenseQuarantineDefectTypeV1ControllerGetByProject = <
  TData = Schemas.QuarantineDefectTypeV1OutputDto,
>(
  variables: QuarantineDefectTypeV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectTypeV1OutputDto,
      QuarantineDefectTypeV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.QuarantineDefectTypeV1OutputDto,
    QuarantineDefectTypeV1ControllerGetByProjectError,
    TData
  >({
    ...quarantineDefectTypeV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useQuarantineDefectTypeV1ControllerGetByProject = <
  TData = Schemas.QuarantineDefectTypeV1OutputDto,
>(
  variables:
    | QuarantineDefectTypeV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.QuarantineDefectTypeV1OutputDto,
      QuarantineDefectTypeV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.QuarantineDefectTypeV1OutputDto,
    QuarantineDefectTypeV1ControllerGetByProjectError,
    TData
  >({
    ...quarantineDefectTypeV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ScanCodeConfigV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type ScanCodeConfigV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type ScanCodeConfigV1ControllerGetByProjectVariables = {
  queryParams: ScanCodeConfigV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchScanCodeConfigV1ControllerGetByProject = (
  variables: ScanCodeConfigV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ScanCodeConfigV1OutputDto,
    ScanCodeConfigV1ControllerGetByProjectError,
    undefined,
    {},
    ScanCodeConfigV1ControllerGetByProjectQueryParams,
    {}
  >({ url: '/scan/scan-code-config', method: 'get', ...variables, signal });

export function scanCodeConfigV1ControllerGetByProjectQuery(
  variables: ScanCodeConfigV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.ScanCodeConfigV1OutputDto>;
};

export function scanCodeConfigV1ControllerGetByProjectQuery(
  variables:
    | ScanCodeConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ScanCodeConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function scanCodeConfigV1ControllerGetByProjectQuery(
  variables:
    | ScanCodeConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/scan-code-config',
      operationId: 'scanCodeConfigV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchScanCodeConfigV1ControllerGetByProject(variables, signal),
  };
}

export const useSuspenseScanCodeConfigV1ControllerGetByProject = <
  TData = Schemas.ScanCodeConfigV1OutputDto,
>(
  variables: ScanCodeConfigV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanCodeConfigV1OutputDto,
      ScanCodeConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ScanCodeConfigV1OutputDto,
    ScanCodeConfigV1ControllerGetByProjectError,
    TData
  >({
    ...scanCodeConfigV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useScanCodeConfigV1ControllerGetByProject = <
  TData = Schemas.ScanCodeConfigV1OutputDto,
>(
  variables:
    | ScanCodeConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanCodeConfigV1OutputDto,
      ScanCodeConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.ScanCodeConfigV1OutputDto,
    ScanCodeConfigV1ControllerGetByProjectError,
    TData
  >({
    ...scanCodeConfigV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ScanConfigV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type ScanConfigV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type ScanConfigV1ControllerGetByProjectVariables = {
  queryParams: ScanConfigV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchScanConfigV1ControllerGetByProject = (
  variables: ScanConfigV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByProjectError,
    undefined,
    {},
    ScanConfigV1ControllerGetByProjectQueryParams,
    {}
  >({ url: '/scan/scan-config', method: 'get', ...variables, signal });

export function scanConfigV1ControllerGetByProjectQuery(
  variables: ScanConfigV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ScanConfigV1OutputDto>;
};

export function scanConfigV1ControllerGetByProjectQuery(
  variables: ScanConfigV1ControllerGetByProjectVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ScanConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function scanConfigV1ControllerGetByProjectQuery(
  variables: ScanConfigV1ControllerGetByProjectVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/scan-config',
      operationId: 'scanConfigV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchScanConfigV1ControllerGetByProject(variables, signal),
  };
}

export const useSuspenseScanConfigV1ControllerGetByProject = <
  TData = Schemas.ScanConfigV1OutputDto,
>(
  variables: ScanConfigV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanConfigV1OutputDto,
      ScanConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByProjectError,
    TData
  >({
    ...scanConfigV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useScanConfigV1ControllerGetByProject = <
  TData = Schemas.ScanConfigV1OutputDto,
>(
  variables: ScanConfigV1ControllerGetByProjectVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanConfigV1OutputDto,
      ScanConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.ScanConfigV1OutputDto,
    ScanConfigV1ControllerGetByProjectError,
    TData
  >({
    ...scanConfigV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ScanSiteV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type ScanSiteV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type ScanSiteV1ControllerGetByProjectVariables = {
  queryParams: ScanSiteV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchScanSiteV1ControllerGetByProject = (
  variables: ScanSiteV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.ScanSiteV1OutputDto,
    ScanSiteV1ControllerGetByProjectError,
    undefined,
    {},
    ScanSiteV1ControllerGetByProjectQueryParams,
    {}
  >({ url: '/scan/scan-site', method: 'get', ...variables, signal });

export function scanSiteV1ControllerGetByProjectQuery(
  variables: ScanSiteV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ScanSiteV1OutputDto>;
};

export function scanSiteV1ControllerGetByProjectQuery(
  variables: ScanSiteV1ControllerGetByProjectVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.ScanSiteV1OutputDto>)
    | reactQuery.SkipToken;
};

export function scanSiteV1ControllerGetByProjectQuery(
  variables: ScanSiteV1ControllerGetByProjectVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/scan-site',
      operationId: 'scanSiteV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchScanSiteV1ControllerGetByProject(variables, signal),
  };
}

export const useSuspenseScanSiteV1ControllerGetByProject = <
  TData = Schemas.ScanSiteV1OutputDto,
>(
  variables: ScanSiteV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanSiteV1OutputDto,
      ScanSiteV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.ScanSiteV1OutputDto,
    ScanSiteV1ControllerGetByProjectError,
    TData
  >({
    ...scanSiteV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useScanSiteV1ControllerGetByProject = <
  TData = Schemas.ScanSiteV1OutputDto,
>(
  variables: ScanSiteV1ControllerGetByProjectVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ScanSiteV1OutputDto,
      ScanSiteV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.ScanSiteV1OutputDto,
    ScanSiteV1ControllerGetByProjectError,
    TData
  >({
    ...scanSiteV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentV1ControllerUpdateStatusPathParams = {
  id: string;
};

export type SegmentV1ControllerUpdateStatusError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerUpdateStatusVariables = {
  body: Schemas.SegmentUpdateV1InputDto;
  pathParams: SegmentV1ControllerUpdateStatusPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerUpdateStatus = (
  variables: SegmentV1ControllerUpdateStatusVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentUpsertV1OutputDto,
    SegmentV1ControllerUpdateStatusError,
    Schemas.SegmentUpdateV1InputDto,
    {},
    {},
    SegmentV1ControllerUpdateStatusPathParams
  >({ url: '/scan/segment/{id}', method: 'put', ...variables, signal });

export const useSegmentV1ControllerUpdateStatus = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentUpsertV1OutputDto,
      SegmentV1ControllerUpdateStatusError,
      SegmentV1ControllerUpdateStatusVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentUpsertV1OutputDto,
    SegmentV1ControllerUpdateStatusError,
    SegmentV1ControllerUpdateStatusVariables
  >({
    mutationFn: (variables: SegmentV1ControllerUpdateStatusVariables) =>
      fetchSegmentV1ControllerUpdateStatus(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export type SegmentV1ControllerCreateError = Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerCreateVariables = {
  body: Schemas.SegmentCreateV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerCreate = (
  variables: SegmentV1ControllerCreateVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentUpsertV1OutputDto,
    SegmentV1ControllerCreateError,
    Schemas.SegmentCreateV1InputDto,
    {},
    {},
    {}
  >({ url: '/scan/segment/scan', method: 'post', ...variables, signal });

export const useSegmentV1ControllerCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentUpsertV1OutputDto,
      SegmentV1ControllerCreateError,
      SegmentV1ControllerCreateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentUpsertV1OutputDto,
    SegmentV1ControllerCreateError,
    SegmentV1ControllerCreateVariables
  >({
    mutationFn: (variables: SegmentV1ControllerCreateVariables) =>
      fetchSegmentV1ControllerCreate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SegmentV1ControllerGetSegmentsQueryParams = {
  projectId: string;
  updatedSince?: string;
};

export type SegmentV1ControllerGetSegmentsError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerGetSegmentsVariables = {
  queryParams: SegmentV1ControllerGetSegmentsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerGetSegments = (
  variables: SegmentV1ControllerGetSegmentsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentSyncV1OutputDto,
    SegmentV1ControllerGetSegmentsError,
    undefined,
    {},
    SegmentV1ControllerGetSegmentsQueryParams,
    {}
  >({ url: '/scan/segments', method: 'get', ...variables, signal });

export function segmentV1ControllerGetSegmentsQuery(
  variables: SegmentV1ControllerGetSegmentsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SegmentSyncV1OutputDto>;
};

export function segmentV1ControllerGetSegmentsQuery(
  variables: SegmentV1ControllerGetSegmentsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SegmentSyncV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentV1ControllerGetSegmentsQuery(
  variables: SegmentV1ControllerGetSegmentsVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/segments',
      operationId: 'segmentV1ControllerGetSegments',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentV1ControllerGetSegments(variables, signal),
  };
}

export const useSuspenseSegmentV1ControllerGetSegments = <
  TData = Schemas.SegmentSyncV1OutputDto,
>(
  variables: SegmentV1ControllerGetSegmentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentSyncV1OutputDto,
      SegmentV1ControllerGetSegmentsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentSyncV1OutputDto,
    SegmentV1ControllerGetSegmentsError,
    TData
  >({
    ...segmentV1ControllerGetSegmentsQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentV1ControllerGetSegments = <
  TData = Schemas.SegmentSyncV1OutputDto,
>(
  variables: SegmentV1ControllerGetSegmentsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentSyncV1OutputDto,
      SegmentV1ControllerGetSegmentsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentSyncV1OutputDto,
    SegmentV1ControllerGetSegmentsError,
    TData
  >({
    ...segmentV1ControllerGetSegmentsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentV1ControllerUploadError = Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerUploadVariables = {
  body: Schemas.SegmentUploadV1InputDto;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerUpload = (
  variables: SegmentV1ControllerUploadVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentUploadV1OutputDto,
    SegmentV1ControllerUploadError,
    Schemas.SegmentUploadV1InputDto,
    {},
    {},
    {}
  >({ url: '/scan/segments', method: 'post', ...variables, signal });

export const useSegmentV1ControllerUpload = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SegmentUploadV1OutputDto,
      SegmentV1ControllerUploadError,
      SegmentV1ControllerUploadVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useApiContext();
  return reactQuery.useMutation<
    Schemas.SegmentUploadV1OutputDto,
    SegmentV1ControllerUploadError,
    SegmentV1ControllerUploadVariables
  >({
    mutationFn: (variables: SegmentV1ControllerUploadVariables) =>
      fetchSegmentV1ControllerUpload(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SegmentV1ControllerSearchQueryParams = {
  serialNumber: string;
  projectId: string;
  date: string;
};

export type SegmentV1ControllerSearchError = Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerSearchVariables = {
  queryParams: SegmentV1ControllerSearchQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerSearch = (
  variables: SegmentV1ControllerSearchVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentV1OutputDto,
    SegmentV1ControllerSearchError,
    undefined,
    {},
    SegmentV1ControllerSearchQueryParams,
    {}
  >({ url: '/scan/segment', method: 'get', ...variables, signal });

export function segmentV1ControllerSearchQuery(
  variables: SegmentV1ControllerSearchVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SegmentV1OutputDto>;
};

export function segmentV1ControllerSearchQuery(
  variables: SegmentV1ControllerSearchVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SegmentV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentV1ControllerSearchQuery(
  variables: SegmentV1ControllerSearchVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/segment',
      operationId: 'segmentV1ControllerSearch',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentV1ControllerSearch(variables, signal),
  };
}

export const useSuspenseSegmentV1ControllerSearch = <
  TData = Schemas.SegmentV1OutputDto,
>(
  variables: SegmentV1ControllerSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentV1OutputDto,
      SegmentV1ControllerSearchError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentV1OutputDto,
    SegmentV1ControllerSearchError,
    TData
  >({
    ...segmentV1ControllerSearchQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentV1ControllerSearch = <
  TData = Schemas.SegmentV1OutputDto,
>(
  variables: SegmentV1ControllerSearchVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentV1OutputDto,
      SegmentV1ControllerSearchError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentV1OutputDto,
    SegmentV1ControllerSearchError,
    TData
  >({
    ...segmentV1ControllerSearchQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentV1ControllerGetDefectsPathParams = {
  id: string;
};

export type SegmentV1ControllerGetDefectsError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentV1ControllerGetDefectsVariables = {
  pathParams: SegmentV1ControllerGetDefectsPathParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentV1ControllerGetDefects = (
  variables: SegmentV1ControllerGetDefectsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentDefectsV1OutputDto,
    SegmentV1ControllerGetDefectsError,
    undefined,
    {},
    {},
    SegmentV1ControllerGetDefectsPathParams
  >({ url: '/scan/segment/{id}/defects', method: 'get', ...variables, signal });

export function segmentV1ControllerGetDefectsQuery(
  variables: SegmentV1ControllerGetDefectsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.SegmentDefectsV1OutputDto>;
};

export function segmentV1ControllerGetDefectsQuery(
  variables: SegmentV1ControllerGetDefectsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.SegmentDefectsV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentV1ControllerGetDefectsQuery(
  variables: SegmentV1ControllerGetDefectsVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/segment/{id}/defects',
      operationId: 'segmentV1ControllerGetDefects',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentV1ControllerGetDefects(variables, signal),
  };
}

export const useSuspenseSegmentV1ControllerGetDefects = <
  TData = Schemas.SegmentDefectsV1OutputDto,
>(
  variables: SegmentV1ControllerGetDefectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDefectsV1OutputDto,
      SegmentV1ControllerGetDefectsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentDefectsV1OutputDto,
    SegmentV1ControllerGetDefectsError,
    TData
  >({
    ...segmentV1ControllerGetDefectsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentV1ControllerGetDefects = <
  TData = Schemas.SegmentDefectsV1OutputDto,
>(
  variables: SegmentV1ControllerGetDefectsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDefectsV1OutputDto,
      SegmentV1ControllerGetDefectsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentDefectsV1OutputDto,
    SegmentV1ControllerGetDefectsError,
    TData
  >({
    ...segmentV1ControllerGetDefectsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentDrawConfigV1ControllerGetByProjectQueryParams = {
  projectId: string;
};

export type SegmentDrawConfigV1ControllerGetByProjectError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentDrawConfigV1ControllerGetByProjectVariables = {
  queryParams: SegmentDrawConfigV1ControllerGetByProjectQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentDrawConfigV1ControllerGetByProject = (
  variables: SegmentDrawConfigV1ControllerGetByProjectVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByProjectError,
    undefined,
    {},
    SegmentDrawConfigV1ControllerGetByProjectQueryParams,
    {}
  >({ url: '/scan/segment-draw-configs', method: 'get', ...variables, signal });

export function segmentDrawConfigV1ControllerGetByProjectQuery(
  variables: SegmentDrawConfigV1ControllerGetByProjectVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.SegmentDrawConfigV1OutputDto>;
};

export function segmentDrawConfigV1ControllerGetByProjectQuery(
  variables:
    | SegmentDrawConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.SegmentDrawConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentDrawConfigV1ControllerGetByProjectQuery(
  variables:
    | SegmentDrawConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/segment-draw-configs',
      operationId: 'segmentDrawConfigV1ControllerGetByProject',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentDrawConfigV1ControllerGetByProject(variables, signal),
  };
}

export const useSuspenseSegmentDrawConfigV1ControllerGetByProject = <
  TData = Schemas.SegmentDrawConfigV1OutputDto,
>(
  variables: SegmentDrawConfigV1ControllerGetByProjectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDrawConfigV1OutputDto,
      SegmentDrawConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByProjectError,
    TData
  >({
    ...segmentDrawConfigV1ControllerGetByProjectQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentDrawConfigV1ControllerGetByProject = <
  TData = Schemas.SegmentDrawConfigV1OutputDto,
>(
  variables:
    | SegmentDrawConfigV1ControllerGetByProjectVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDrawConfigV1OutputDto,
      SegmentDrawConfigV1ControllerGetByProjectError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByProjectError,
    TData
  >({
    ...segmentDrawConfigV1ControllerGetByProjectQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SegmentDrawConfigV1ControllerGetByScanSiteQueryParams = {
  scanSiteId: string;
};

export type SegmentDrawConfigV1ControllerGetByScanSiteError =
  Fetcher.ErrorWrapper<undefined>;

export type SegmentDrawConfigV1ControllerGetByScanSiteVariables = {
  queryParams: SegmentDrawConfigV1ControllerGetByScanSiteQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchSegmentDrawConfigV1ControllerGetByScanSite = (
  variables: SegmentDrawConfigV1ControllerGetByScanSiteVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByScanSiteError,
    undefined,
    {},
    SegmentDrawConfigV1ControllerGetByScanSiteQueryParams,
    {}
  >({
    url: '/scan/segment-draw-configs/by-scan-site',
    method: 'get',
    ...variables,
    signal,
  });

export function segmentDrawConfigV1ControllerGetByScanSiteQuery(
  variables: SegmentDrawConfigV1ControllerGetByScanSiteVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<Schemas.SegmentDrawConfigV1OutputDto>;
};

export function segmentDrawConfigV1ControllerGetByScanSiteQuery(
  variables:
    | SegmentDrawConfigV1ControllerGetByScanSiteVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<Schemas.SegmentDrawConfigV1OutputDto>)
    | reactQuery.SkipToken;
};

export function segmentDrawConfigV1ControllerGetByScanSiteQuery(
  variables:
    | SegmentDrawConfigV1ControllerGetByScanSiteVariables
    | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/segment-draw-configs/by-scan-site',
      operationId: 'segmentDrawConfigV1ControllerGetByScanSite',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchSegmentDrawConfigV1ControllerGetByScanSite(variables, signal),
  };
}

export const useSuspenseSegmentDrawConfigV1ControllerGetByScanSite = <
  TData = Schemas.SegmentDrawConfigV1OutputDto,
>(
  variables: SegmentDrawConfigV1ControllerGetByScanSiteVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDrawConfigV1OutputDto,
      SegmentDrawConfigV1ControllerGetByScanSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByScanSiteError,
    TData
  >({
    ...segmentDrawConfigV1ControllerGetByScanSiteQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useSegmentDrawConfigV1ControllerGetByScanSite = <
  TData = Schemas.SegmentDrawConfigV1OutputDto,
>(
  variables:
    | SegmentDrawConfigV1ControllerGetByScanSiteVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.SegmentDrawConfigV1OutputDto,
      SegmentDrawConfigV1ControllerGetByScanSiteError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.SegmentDrawConfigV1OutputDto,
    SegmentDrawConfigV1ControllerGetByScanSiteError,
    TData
  >({
    ...segmentDrawConfigV1ControllerGetByScanSiteQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type RingV1ControllerGetRingsQueryParams = {
  scanSiteId?: string;
  updatedSince?: string;
};

export type RingV1ControllerGetRingsError = Fetcher.ErrorWrapper<undefined>;

export type RingV1ControllerGetRingsVariables = {
  queryParams?: RingV1ControllerGetRingsQueryParams;
} & ApiContext['fetcherOptions'];

export const fetchRingV1ControllerGetRings = (
  variables: RingV1ControllerGetRingsVariables,
  signal?: AbortSignal,
) =>
  apiFetch<
    Schemas.RingSyncV1OutputDto,
    RingV1ControllerGetRingsError,
    undefined,
    {},
    RingV1ControllerGetRingsQueryParams,
    {}
  >({ url: '/scan/rings', method: 'get', ...variables, signal });

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.RingSyncV1OutputDto>;
};

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<Schemas.RingSyncV1OutputDto>)
    | reactQuery.SkipToken;
};

export function ringV1ControllerGetRingsQuery(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
) {
  return {
    queryKey: queryKeyFn({
      path: '/scan/rings',
      operationId: 'ringV1ControllerGetRings',
      variables,
    }),
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchRingV1ControllerGetRings(variables, signal),
  };
}

export const useSuspenseRingV1ControllerGetRings = <
  TData = Schemas.RingSyncV1OutputDto,
>(
  variables: RingV1ControllerGetRingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingSyncV1OutputDto,
      RingV1ControllerGetRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.RingSyncV1OutputDto,
    RingV1ControllerGetRingsError,
    TData
  >({
    ...ringV1ControllerGetRingsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRingV1ControllerGetRings = <
  TData = Schemas.RingSyncV1OutputDto,
>(
  variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.RingSyncV1OutputDto,
      RingV1ControllerGetRingsError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { queryOptions, fetcherOptions } = useApiContext(options);
  return reactQuery.useQuery<
    Schemas.RingSyncV1OutputDto,
    RingV1ControllerGetRingsError,
    TData
  >({
    ...ringV1ControllerGetRingsQuery(
      variables === reactQuery.skipToken
        ? variables
        : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: '/scan/defect-repair-type';
      operationId: 'defectRepairTypeV1ControllerGetByProject';
      variables:
        | DefectRepairTypeV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/quarantine-defect/{id}';
      operationId: 'quarantineDefectV1ControllerGetById';
      variables:
        | QuarantineDefectV1ControllerGetByIdVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/quarantine-defect-type';
      operationId: 'quarantineDefectTypeV1ControllerGetByProject';
      variables:
        | QuarantineDefectTypeV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/scan-code-config';
      operationId: 'scanCodeConfigV1ControllerGetByProject';
      variables:
        | ScanCodeConfigV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/scan-config';
      operationId: 'scanConfigV1ControllerGetByProject';
      variables:
        | ScanConfigV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/scan-site';
      operationId: 'scanSiteV1ControllerGetByProject';
      variables:
        | ScanSiteV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/segments';
      operationId: 'segmentV1ControllerGetSegments';
      variables: SegmentV1ControllerGetSegmentsVariables | reactQuery.SkipToken;
    }
  | {
      path: '/scan/segment';
      operationId: 'segmentV1ControllerSearch';
      variables: SegmentV1ControllerSearchVariables | reactQuery.SkipToken;
    }
  | {
      path: '/scan/segment/{id}/defects';
      operationId: 'segmentV1ControllerGetDefects';
      variables: SegmentV1ControllerGetDefectsVariables | reactQuery.SkipToken;
    }
  | {
      path: '/scan/segment-draw-configs';
      operationId: 'segmentDrawConfigV1ControllerGetByProject';
      variables:
        | SegmentDrawConfigV1ControllerGetByProjectVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/segment-draw-configs/by-scan-site';
      operationId: 'segmentDrawConfigV1ControllerGetByScanSite';
      variables:
        | SegmentDrawConfigV1ControllerGetByScanSiteVariables
        | reactQuery.SkipToken;
    }
  | {
      path: '/scan/rings';
      operationId: 'ringV1ControllerGetRings';
      variables: RingV1ControllerGetRingsVariables | reactQuery.SkipToken;
    };
